/*
Окна сообщений
*/
var alertBox = document.createElement('ul');
alertBox.classList.add('alertBox');
document.body.append(alertBox);

export function echo(msg, type = 'msg') {//type err,
    var li = document.createElement('li');
    li.onclick = pause;
    li.classList.add('alert');
    li.innerHTML = "<div>" + msg + "</div>";
    var stripe = document.createElement('div');
    //stripe.classList.remove('animate');
    stripe.classList.add('duration-line');
    stripe.onanimationend = onTransEnd;
    li.append(stripe);
    alertBox.append(li);
}
// echo("<h4>Удаление страницы</h4><hr><p>Невозможно удалить страницу, пока у неё есть потомки.</p>");
// setTimeout(() => echo("<h4>Сообщение</h4><hr><p>Окон может быть несколько.</p>"), 3000);
// setTimeout(() => echo("3. Они выводяться на время и сами закрываютя."), 6000);
// setTimeout(() => echo("4. Кликните по окну чтобы остановить время показа."), 9000);

function onTransEnd() {
    //console.log(this.parentElement);
    this.parentElement.remove()
}

//echo();
function pause() {
    var currEl = this.querySelector('div:last-child');
    //console.log(currEl);
    currEl.classList.toggle('pause');
}
